import { Link } from 'react-router-dom';
import { Cpu, Facebook, Instagram } from 'lucide-react';
import { useCMS } from '../hooks/useCMS';

export default function Footer() {
  const currentYear = new Date().getFullYear();
  // 社交連結 CMS 可改（footer.social.facebook / footer.social.instagram；空＝唔顯示）
  const { getValue } = useCMS();
  const facebookUrl = getValue('footer.social.facebook', '');
  const instagramUrl = getValue('footer.social.instagram', '');

  return (
    <footer className="bg-x1493-dark text-white/70 py-12 border-t border-white/10">
      <div className="max-w-6xl mx-auto px-4">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-8">
          <div>
            <div className="flex items-center gap-2 mb-4">
              <div className="w-10 h-10 rounded-xl bg-x1493-primary flex items-center justify-center">
                <Cpu size={22} className="text-white" />
              </div>
              <span className="text-xl font-bold text-white">Kare Tech</span>
            </div>
            <p className="text-sm leading-relaxed">
              IT 產品與工程器材專門店。由網絡設備、電腦配件，到工具儀器、開發板與自動化感應器，專業裝備一站式採購，網購直送全港。
            </p>
          </div>

          <div>
            <h4 className="text-white font-bold mb-4">探索</h4>
            <ul className="space-y-2 text-sm">
              <li><Link to="/" className="hover:text-x1493-secondary transition">首頁</Link></li>
              <li><Link to="/story" className="hover:text-x1493-secondary transition">關於我們</Link></li>
              <li><Link to="/store" className="hover:text-x1493-secondary transition">商店</Link></li>
              <li><Link to="/order/query" className="hover:text-x1493-secondary transition">訂單查詢</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="text-white font-bold mb-4">客戶服務</h4>
            <ul className="space-y-2 text-sm">
              <li><Link to="/terms" className="hover:text-x1493-secondary transition">條款及細則</Link></li>
              <li><Link to="/privacy" className="hover:text-x1493-secondary transition">隱私條款</Link></li>
              <li className="text-white/50">聯絡方式即將公佈</li>
            </ul>
          </div>
        </div>

        <div className="border-t border-white/10 pt-6 flex flex-col md:flex-row justify-between items-center gap-4 text-xs">
          <p>© {currentYear} Kare Tech. 專業 IT 與工程裝備</p>
          <div className="flex items-center gap-4">
            <Link to="/terms" className="hover:text-x1493-secondary transition">條款及細則</Link>
            <span className="text-white/30">|</span>
            <Link to="/privacy" className="hover:text-x1493-secondary transition">隱私條款</Link>
            {(facebookUrl || instagramUrl) && <span className="text-white/30">|</span>}
            {facebookUrl && (
              <a
                href={facebookUrl}
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Facebook"
                className="inline-flex items-center gap-1 hover:text-x1493-secondary transition"
              >
                <Facebook size={16} /> Facebook
              </a>
            )}
            {instagramUrl && (
              <a
                href={instagramUrl}
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Instagram"
                className="inline-flex items-center gap-1 hover:text-x1493-secondary transition"
              >
                <Instagram size={16} /> Instagram
              </a>
            )}
          </div>
          <p>
            Powered by{' '}
            <a
              href="https://jkdcoding.com/"
              target="_blank"
              rel="noopener noreferrer"
              className="font-bold text-yellow-300 hover:underline"
            >
              JKD<span className="text-white">Coding</span>
            </a>
          </p>
        </div>
      </div>
    </footer>
  );
}
